import { Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ResolvedFieldSource } from './DeclarationSourceContext';
import { IconWrapper } from './styles';
import { SOURCE_COLOURS, SOURCE_ICONS, tooltip } from './utils';

export interface DeclarationValueSourceIconProps extends ResolvedFieldSource {
    className?: string;
}

/**
 * Indicates where a pre-filled value came from, or — once the user edits it — that it no longer matches
 * its source. Purely presentational: see `useDeclarationValueSource` for resolving these props.
 */
const DeclarationValueSourceIcon = ({ source, overridden, className }: DeclarationValueSourceIconProps) => {
    const colours = overridden ? SOURCE_COLOURS.override : SOURCE_COLOURS[source];

    return (
        <Tooltip title={tooltip(source, overridden)}>
            <IconWrapper
                className={className}
                $color={colours.color}
                $backgroundColor={colours.backgroundColor}
                $borderColor={colours.borderColor}
            >
                {overridden ? <EditOutlined /> : SOURCE_ICONS[source]}
            </IconWrapper>
        </Tooltip>
    );
};

export default DeclarationValueSourceIcon;
